import { AlertCircle } from 'lucide-react';
import { errorMessage } from '../api';
import { Skeleton } from './ui/skeleton';

/** Loading: announced in text, shown as a skeleton of the content to come */
export function Loading({ label = 'Loading', rows = 3 }: { label?: string; rows?: number }) {
  return (
    <div className="state state-loading" role="status" aria-live="polite">
      <span className="flex items-center gap-2 text-sm text-muted-foreground">
        <span className="spinner" aria-hidden="true" />
        <span>{label}…</span>
      </span>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} className={i === 0 ? 'h-12' : 'h-12 opacity-70'} />
      ))}
    </div>
  );
}

export function ErrorState({ error, title = 'Something went wrong', onRetry }: { error: unknown; title?: string; onRetry?: (() => void) | undefined }) {
  return (
    <div className="state state-error" role="alert">
      <div className="flex items-start gap-3">
        <AlertCircle className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
        <div className="grid gap-2">
          <h2 className="state-title">{title}</h2>
          <p className="m-0">{errorMessage(error)}</p>
          {onRetry ? (
            <div>
              <button type="button" className="button" onClick={onRetry}>
                Try again
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

// Empty states (v2) live in their own module; this re-export keeps every existing import working.
export { EmptyChrome, EmptyState, type EmptyStateIcon, type EmptyStateProps, type EmptyStep } from './empty-state';

/** Inline form error, announced to screen readers. */
export function FormError({ error }: { error: unknown }) {
  if (!error) return null;
  return (
    <p className="form-error" role="alert">
      {errorMessage(error)}
    </p>
  );
}
